import {
  IAMCredentialStatus,
  IIAMCredentialMeta,
} from "api/entities/iam-credentials";
import { iamService } from "api/services/iam";
import { Switch } from "components/shared-ui/input/switch/switch";
import React from "react";
import { useApi } from "utils/hooks/use-api";

export interface IStatusProps {
  data: IIAMCredentialMeta;
  refresh?: () => void;
}

export default function IAMCredentialStatusToggle(props: IStatusProps) {
  const [api] = useApi();

  const toggleStatus = (status: IAMCredentialStatus): IAMCredentialStatus => {
    if (status === IAMCredentialStatus.Active)
      return IAMCredentialStatus.Inactive;
    return IAMCredentialStatus.Active;
  };

  const handleChange = () => {
    api(
      iamService
        .updateAccessKey({
          AccessKeyId: props.data.AccessKeyId,
          Status: toggleStatus(props.data.Status),
          UserName: props.data.UserName
        })
        .then(() => {
          props.refresh?.();
        })
    );
  };

  return (
    <Switch
      testId={props.data.AccessKeyId}
      checked={props.data.Status === IAMCredentialStatus.Active}
      onChange={handleChange}
      label="Active"
    />
  );
}
